var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import MuiCard from "@material-ui/core/Card";
import { fade } from "@material-ui/core/styles/colorManipulator";
import capitalize from "@material-ui/core/utils/capitalize";
import { makeStyles, styled } from "../styles";
import { compose, display, flexbox, grid, positions, shadows, sizing, spacing, } from "../system";
import clsx from "../utils/clsx";
import { CardContext } from "./card-context";
export var CardComponentName = "CosmosCard";
export var useCardStyles = makeStyles(function (theme) { return ({
    root: {},
    button: {
        borderColor: theme.palette.border.dark,
        cursor: "pointer",
        transition: theme.transitions.create("box-shadow", { duration: theme.transitions.duration.shortest }),
        "&:hover": {
            boxShadow: theme.shadows[1],
        },
        "&:focus": __assign({ outline: "none" }, theme.mixins.focusRing()),
    },
    selectableButton: {
        cursor: "pointer",
        transition: theme.transitions.create(["box-shadow", "border-color"], {
            duration: theme.transitions.duration.shortest,
        }),
        "&:hover": {
            backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        },
    },
    sizeSmall: {
        padding: theme.spacing(2),
    },
    sizeMedium: {
        padding: theme.spacing(3),
    },
    sizeLarge: {
        borderRadius: 6,
        padding: theme.spacing(4),
    },
    sizeXlarge: {
        borderRadius: 6,
        padding: theme.spacing(5),
    },
    selected: {
        boxShadow: theme.mixins.borderAsBoxShadow(theme.palette.primary.main, 1),
        borderColor: theme.palette.primary.main,
        "&:hover": {
            boxShadow: theme.mixins.borderAsBoxShadow(theme.palette.primary.main, 1),
            borderColor: theme.palette.primary.main,
        },
        "&$disabled": {
            boxShadow: theme.mixins.borderAsBoxShadow(theme.mixins.shadeOfColor("neutral", "base"), 2),
            borderColor: "transparent",
        },
    },
    disabled: {
        cursor: "not-allowed",
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.action.disabledBackground,
        "&:not($selected)": {
            "&:hover": {
                boxShadow: "none",
            },
        },
    },
}); }, { name: CardComponentName });
var SystemCard = styled(
// wrapping this allows overriding the component from the outside while keeping the styled card
React.forwardRef(function (_a, ref) {
    var innerComponent = _a.innerComponent, props = __rest(_a, ["innerComponent"]);
    return React.createElement(MuiCard, __assign({ component: innerComponent, ref: ref }, props));
}))(compose(display, grid, sizing, spacing, flexbox, positions, shadows));
export var Card = React.forwardRef(function (props, ref) {
    var classes = useCardStyles(props);
    var button = props.button, component = props.component, disabled = props.disabled, className = props.className, selected = props.selected, selectableButton = props.selectableButton, _a = props.size, size = _a === void 0 ? "large" : _a, 
    // remove to prevent passing through to the root
    propClasses = props.classes, rootProps = __rest(props, ["button", "component", "disabled", "className", "selected", "selectableButton", "size", "classes"]);
    return (React.createElement(CardContext.Provider, { value: { size: size } },
        React.createElement(SystemCard, __assign({ innerComponent: component, className: clsx(classes.root, selectableButton && classes.selectableButton, button && classes.button, disabled && classes.disabled, selected && classes.selected, size && classes["size" + capitalize(size)], className), role: button ? "button" : undefined, tabIndex: button && !disabled ? 0 : undefined, "aria-disabled": disabled, ref: ref }, rootProps))));
});
